import React from 'react';
import api from './api';
import { usePublicData } from './publicData';

export function useOfferCatalog() {
  const initial = usePublicData();
  const [offers, setOffers] = React.useState(initial.services || []);
  React.useEffect(() => {
    let active = true;
    api.get('/services').then(r => { if (active) setOffers(r.data); }).catch(() => {});
    return () => { active = false; };
  }, []);
  return offers;
}